<script setup>
import Badge from "@Components/Badge.vue";
import { CheckIcon, FolderIcon, LayersIcon, UserIcon } from "lucide-vue-next";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    currentStep: {
        type: String,
        required: true,
    },
});

const { t: __ } = useI18n();

const steps = ref([
    {
        key: "categories",
        icon: LayersIcon,
        name: __("Création des catégories"),
        status: "outgoing",
    },
    {
        key: "profiles",
        icon: UserIcon,
        name: __("Création des profils"),
        status: "outgoing",
    },
    {
        key: "projects",
        icon: FolderIcon,
        name: __("Création des projets"),
        status: "outgoing",
    },
]);

watch(
    () => props.currentStep,
    (newVal) => {
        let set = false;
        steps.value.forEach((step) => {
            if (step.key === newVal) {
                step.status = "current";
                set = true;
            } else if (set) {
                step.status = "outgoing";
            } else {
                step.status = "complete";
            }
        });
    },
    { immediate: true }
);
</script>

<template>
    <nav aria-label="Progress">
        <ol role="list" class="grid grid-cols-3">
            <li v-for="(step, stepIdx) in steps" :key="step.name" :class="[stepIdx !== steps.length - 1 ? 'pb-10' : '', 'relative']">
                <div
                    v-if="stepIdx !== steps.length - 1"
                    :class="[
                        '-ml-px w-full h-0.5 absolute top-6 left-6 translate-x-1/2',
                        step.status === 'complete' ? 'bg-gray-900 dark:bg-gray-800' : 'bg-gray-300 dark:bg-gray-900',
                    ]"
                    aria-hidden="true" />
                <div class="relative flex flex-col items-center group">
                    <div
                        :class="[
                            'size-12 relative z-10 flex justify-center items-center rounded-full',
                            step.status === 'complete' ? 'bg-gray-900 text-white dark:bg-gray-800' : '',
                            step.status === 'current' ? 'text-gray-900 bg-gray-100 dark:bg-gray-900 dark:text-white' : '',
                            step.status === 'outgoing' ? 'text-gray-400 bg-gray-100 dark:bg-gray-900 dark:text-gray-600' : '',
                        ]">
                        <component :is="step.status === 'complete' ? CheckIcon : step.icon" class="size-7" aria-hidden="true" />
                    </div>
                    <div
                        :class="[
                            'mt-3 text-sm font-medium ',
                            step.status === 'complete' ? 'text-gray-900 dark:text-white' : '',
                            step.status === 'current' ? 'text-gray-900 dark:text-white' : '',
                            step.status === 'outgoing' ? 'text-gray-400 dark:text-gray-600' : '',
                        ]">
                        {{ step.name }}
                    </div>
                    <Badge v-if="step.status === 'current'" class="mt-2">{{ __("En cours") }}</Badge>
                </div>
            </li>
        </ol>
    </nav>
</template>
